var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "356.385574px",
    height: "356.385574px",
    viewBox: "0 0 356.385574 356.385574",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179,0 L244.637781,64 L185,63.999 L184.999,172.5 L292.385,172.5 L292.385574,111.627707 L356.385574,178.5 L292.385574,244.387289 L292.385,184.5 L184.999,184.5 L185,292.385 L244.637781,292.385574 L179,356.385574 L112.347675,292.385574 L173,292.385 L172.999,184.5 L64,184.5 L64,243.321314 L8.92995612e-14,178.5 L64,116.1951 L63.999,172.5 L172.999,172.5 L173,64 L112.683399,64 L179,0 Z",
    id: "Combined-Shape-Copy",
    fill: "#FFA839",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,83.8855735 L194.5,160.385574 L271,160.385574 L271,193.385574 L194.5,193.385574 L194.5,269.885574 L161.5,269.885574 L161.5,193.385574 L85,193.385574 L85,160.385574 L161.5,160.385574 L161.5,83.8855735 L194.5,83.8855735 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.a23c7a8f133263adce2ab9683ce597c7.svg";
export { ForwardRef as ReactComponent };